import React, { useState, useEffect } from "react"
import ReactCountryFlag from "react-country-flag"
import { Tooltip } from "antd"
import "./CountryFlags.scss"

const CountryFlags = ({ countries, countryCodes, displayNumber = 4 }) => {
  const [countriesToDisplay, setCountriesToDisplay] = useState([])
  const [countriesInTooltip, setCountriesInTooltip] = useState([])

  useEffect(() => {
    if (countryCodes) {
      if (countryCodes.length > displayNumber) {
        const countriesToDisplay = countryCodes.slice(0, displayNumber)
        const countryCodesInTooltip = countryCodes.slice(displayNumber, countryCodes.length)
        const countriesInTooltip = Object.keys(countries).reduce((acc, key) => {
          if (countryCodesInTooltip.includes(countries[key].iso2)) {
            acc.push(countries[key].label)
          }
          return acc
        }, [])

        setCountriesToDisplay(countriesToDisplay)
        setCountriesInTooltip(countriesInTooltip.join(", "))
      } else {
        setCountriesToDisplay(countryCodes)
      }
    }
  }, [countryCodes, countries])

  if (!countries || !countryCodes) return null

  return (
    <div className="country-flags">
      {countriesToDisplay.map((code) => {
        const foundCountryKey = Object.keys(countries).find((key) => countries?.[key]?.iso2 === code)
        const countryName = countries[foundCountryKey].label

        const flag = (
          <div
            key={code}
            className="flag-wrapper"
          >
            <ReactCountryFlag
              style={{ width: "22px", height: "15px" }}
              svg
              countryCode={code}
            />
          </div>
        )

        if (countryName) {
          return (
            <Tooltip
              key={code}
              title={countryName}
            >
              {flag}
            </Tooltip>
          )
        }
        return flag
      })}
      {countriesInTooltip.length > 0 && (
        <Tooltip
          title={countriesInTooltip}
          overlayStyle={{ maxWidth: "500px" }}
          className="country-flags-wrap"
        >
          <i className="fa-solid fa-circle-ellipsis" />
        </Tooltip>
      )}
    </div>
  )
}

export default CountryFlags
